<div class="align-buttons">
  <div class="d-flex flex-wrap align-items-center justify-content-end gap-2">
    <span class="small text-muted text-uppercase">{{'SEE_ALSO' | translate}}&nbsp;:</span>
    @for (categoryDesc of _otherCategories; track categoryDesc) {
      <button type="button" class="btn btn-light btn-sm py-0 px-2"
        (click)="gotoTarget(categoryDesc.name)">
        <i class="fas fa-shopping-cart pr-1"></i>
        <span>{{categoryDesc.title | translate}}</span>
      </button>
    }
    <span class="text-muted mx-1">|</span>
    <span class="small text-muted text-uppercase">{{'SHARE' | translate}}&nbsp;:</span>
    <a class="custom-btn btn-social" (click)="fbshareCurrentPage()">
      <i class="fab fa-fw fa-facebook-f"></i>
    </a>
    <a class="custom-btn btn-social twiter-color" (click)="twshareCurrentPage()">
      <i class="fab fa-fw fa-twitter"></i>
    </a>
  </div>
</div>
